var map = {
	"./ad.svg": 98478,
	"./ae.svg": 69151,
	"./af.svg": 81313,
	"./ag.svg": 59282,
	"./ai.svg": 92500,
	"./al.svg": 95554,
	"./am.svg": 80472,
	"./ao.svg": 52886,
	"./ar.svg": 7323,
	"./as.svg": 18594,
	"./at.svg": 93281,
	"./au.svg": 49714,
	"./aw.svg": 8840,
	"./az.svg": 68484,
	"./ba.svg": 43355,
	"./bb.svg": 31598,
	"./bd.svg": 20169,
	"./be.svg": 87251,
	"./bf.svg": 53937,
	"./bg.svg": 95673,
	"./bh.svg": 51528,
	"./bi.svg": 90937,
	"./bj.svg": 10697,
	"./bm.svg": 98565,
	"./bo.svg": 43670,
	"./br.svg": 57719,
	"./bs.svg": 4578,
	"./bt.svg": 71684,
	"./bw.svg": 96808,
	"./by.svg": 31508,
	"./bz.svg": 68894,
	"./ca.svg": 46585,
	"./cd.svg": 95355,
	"./cf.svg": 3479,
	"./cg.svg": 11287,
	"./ch.svg": 14821,
	"./ci.svg": 28863,
	"./ck.svg": 14938,
	"./cl.svg": 65548,
	"./cm.svg": 6664,
	"./cn.svg": 53725,
	"./co.svg": 22176,
	"./cr.svg": 93613,
	"./cu.svg": 45842,
	"./cv.svg": 50576,
	"./cw.svg": 19969,
	"./cy.svg": 39705,
	"./cz.svg": 95805,
	"./de.svg": 33368,
	"./dj.svg": 35770,
	"./dk.svg": 7920,
	"./dm.svg": 21560,
	"./do.svg": 71225,
	"./dz.svg": 73126,
	"./ec.svg": 72420,
	"./ee.svg": 25119,
	"./eg.svg": 26321,
	"./er.svg": 8061,
	"./es.svg": 99881,
	"./et.svg": 42430,
	"./fi.svg": 25113,
	"./fj.svg": 84783,
	"./fk.svg": 12484,
	"./fm.svg": 8033,
	"./fo.svg": 66645,
	"./fr.svg": 69842,
	"./ga.svg": 50294,
	"./gb.svg": 75238,
	"./gd.svg": 32047,
	"./ge.svg": 50993,
	"./gg.svg": 62744,
	"./gh.svg": 78785,
	"./gi.svg": 54678,
	"./gl.svg": 66470,
	"./gm.svg": 94059,
	"./gn.svg": 16101,
	"./gq.svg": 29378,
	"./gr.svg": 17981,
	"./gt.svg": 3262,
	"./gu.svg": 10617,
	"./gw.svg": 54518,
	"./hk.svg": 69845,
	"./hn.svg": 57604,
	"./hr.svg": 77084,
	"./ht.svg": 1223,
	"./hu.svg": 28353,
	"./id.svg": 22801,
	"./ie.svg": 59934,
	"./il.svg": 25452,
	"./im.svg": 99667,
	"./in.svg": 72988,
	"./io.svg": 88050,
	"./iq.svg": 23091,
	"./ir.svg": 72719,
	"./is.svg": 35733,
	"./it.svg": 76283,
	"./je.svg": 63103,
	"./jm.svg": 84127,
	"./jo.svg": 70488,
	"./jp.svg": 58913,
	"./ke.svg": 227,
	"./kg.svg": 53871,
	"./kh.svg": 9321,
	"./ki.svg": 98074,
	"./km.svg": 24881,
	"./kn.svg": 65104,
	"./kp.svg": 1752,
	"./kr.svg": 53935,
	"./kw.svg": 76868,
	"./ky.svg": 1403,
	"./kz.svg": 54653,
	"./la.svg": 83248,
	"./lb.svg": 42557,
	"./li.svg": 16296,
	"./lk.svg": 49800,
	"./lr.svg": 81172,
	"./ls.svg": 66077,
	"./lt.svg": 38444,
	"./lu.svg": 97024,
	"./lv.svg": 59878,
	"./ly.svg": 97131,
	"./ma.svg": 44202,
	"./mc.svg": 8762,
	"./md.svg": 90027,
	"./me.svg": 85352,
	"./mg.svg": 10959,
	"./mh.svg": 22363,
	"./mk.svg": 87243,
	"./ml.svg": 84645,
	"./mm.svg": 13677,
	"./mn.svg": 79065,
	"./mo.svg": 86504,
	"./mp.svg": 85990,
	"./mq.svg": 70459,
	"./mr.svg": 97335,
	"./ms.svg": 37069,
	"./mt.svg": 35362,
	"./mu.svg": 63649,
	"./mv.svg": 54779,
	"./mw.svg": 87717,
	"./mx.svg": 86937,
	"./my.svg": 10962,
	"./mz.svg": 99436,
	"./na.svg": 63254,
	"./nato.svg": 68329,
	"./ne.svg": 816,
	"./nf.svg": 56194,
	"./ng.svg": 28327,
	"./ni.svg": 1963,
	"./nl.svg": 31658,
	"./no.svg": 52883,
	"./np.svg": 17035,
	"./nr.svg": 61795,
	"./nu.svg": 9415,
	"./nz.svg": 11935,
	"./om.svg": 68090,
	"./pa.svg": 33576,
	"./pe.svg": 74459,
	"./pf.svg": 89741,
	"./pg.svg": 7517,
	"./ph.svg": 87059,
	"./pk.svg": 17408,
	"./pl.svg": 44365,
	"./pn.svg": 39245,
	"./pr.svg": 20132,
	"./ps.svg": 16283,
	"./pt.svg": 10542,
	"./pw.svg": 47127,
	"./py.svg": 24985,
	"./qa.svg": 75791,
	"./ro.svg": 45620,
	"./rs.svg": 79274,
	"./ru.svg": 58846,
	"./rw.svg": 3700,
	"./sa.svg": 13142,
	"./sb.svg": 45482,
	"./sc.svg": 2373,
	"./sd.svg": 92071,
	"./se.svg": 68321,
	"./sg.svg": 66832,
	"./si.svg": 53781,
	"./sk.svg": 73980,
	"./sl.svg": 92950,
	"./sm.svg": 46069,
	"./sn.svg": 21233,
	"./so.svg": 59617,
	"./sr.svg": 85869,
	"./ss.svg": 89593,
	"./st.svg": 18640,
	"./sv.svg": 94520,
	"./sx.svg": 49582,
	"./sy.svg": 4438,
	"./sz.svg": 1833,
	"./tc.svg": 90611,
	"./td.svg": 11536,
	"./tg.svg": 17661,
	"./th.svg": 8143,
	"./tibet.svg": 6697,
	"./tj.svg": 48914,
	"./tk.svg": 83186,
	"./tm.svg": 81795,
	"./tn.svg": 99670,
	"./to.svg": 75510,
	"./tr.svg": 61649,
	"./tt.svg": 18682,
	"./tv.svg": 9142,
	"./tw.svg": 78983,
	"./tz.svg": 30460,
	"./ua.svg": 85808,
	"./ug.svg": 55837,
	"./us.svg": 63111,
	"./uy.svg": 8407,
	"./uz.svg": 11426,
	"./ve.svg": 13736,
	"./vi.svg": 35041,
	"./vn.svg": 50798,
	"./vu.svg": 43630,
	"./ws.svg": 33828,
	"./ye.svg": 24488,
	"./za.svg": 43108,
	"./zm.svg": 40343,
	"./zw.svg": 84280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52107;